var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 158,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M75 158c41.421 0 75-33.579 75-75S116.421 8 75 8 0 41.579 0 83s33.579 75 75 75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M83 79H39a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6ZM83 106H39a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6ZM83 133H39a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A2BDFA",
    d: "M130.363 52.929v64.81c0 2.581-2.15 4.581-4.549 4.581h-99.23c-2.553 0-4.565-2.097-4.565-4.581v-64.81L73.04 8.688a4.576 4.576 0 0 1 5.978-.017l51.348 44.258h-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.512 21.137v88.98a3.423 3.423 0 0 1-3.424 3.424H29.296a3.423 3.423 0 0 1-3.424-3.424v-88.98a4.792 4.792 0 0 1 4.792-4.793h91.058a4.791 4.791 0 0 1 4.792 4.793h-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75DDB8",
    d: "M76 62.5c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74.316 51.984c-.383.001-.755-.123-1.061-.352l-.019-.014-3.995-3.056a1.777 1.777 0 0 1 2.16-2.819l2.588 1.985 6.115-7.978a1.775 1.775 0 0 1 2.488-.328l-.037.053.039-.053a1.777 1.777 0 0 1 .328 2.489L75.73 51.29a1.776 1.776 0 0 1-1.413.692l-.001.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83A9FE",
    d: "m130.363 52.929-.048 65.374a4.433 4.433 0 0 1-1.489 2.84c-.047.046-.095.078-.142.125L76.192 87.695l5.46-3.5 48.713-31.266h-.002ZM76.191 87.695l-52.493 33.589c-.74-.557-1.496-1.713-1.632-2.981l-.047-65.374L70.512 84.07l5.68 3.624Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2BDFA",
    d: "M128.825 121.141v.005c-1.45 1.283-2.888 1.14-3.043 1.172l-99.764-.046c-.964-.104-1.893-.531-2.666-1.302l47.16-36.899 3.275-2.563a3.597 3.597 0 0 1 4.431 0l3.433 2.688 47.176 36.947-.002-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1C5",
    d: "m123.721 9.841-.081-.001a1.276 1.276 0 0 1-1.193-1.35l.456-7.295a1.28 1.28 0 0 1 1.35-1.191 1.276 1.276 0 0 1 1.193 1.35l-.455 7.294a1.274 1.274 0 0 1-1.27 1.195v-.002ZM131.577 13.42a1.275 1.275 0 0 1 0-1.8l5.169-5.167a1.273 1.273 0 0 1 1.801 1.8l-5.169 5.168c-.502.5-1.306.493-1.801 0ZM135.16 21.36a1.274 1.274 0 0 1 1.193-1.35l7.295-.456c.67-.046 1.305.49 1.35 1.191a1.273 1.273 0 0 1-1.193 1.35l-7.294.456a1.273 1.273 0 0 1-1.351-1.191ZM28.662 9.841c-.666 0-1.227-.52-1.27-1.194l-.456-7.295a1.273 1.273 0 0 1 2.544-.159l.455 7.295a1.273 1.273 0 0 1-1.193 1.35l-.08.002v.001ZM19.003 13.42l-5.168-5.166a1.274 1.274 0 0 1 1.8-1.8l5.168 5.166a1.274 1.274 0 0 1-1.8 1.8ZM15.954 22.553c-.027 0-.054 0-.08-.002l-7.295-.455a1.276 1.276 0 0 1-1.193-1.35c.045-.703.68-1.23 1.35-1.192l7.295.456a1.274 1.274 0 0 1-.077 2.545v-.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 75,
    x2: 75,
    y1: 8,
    y2: 158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.384 0H145v122.318H7.384z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/email-verified.a8fd9b4c6108db6b9e91e8fba1111c51.svg";
export { ForwardRef as ReactComponent };